import { IonCardContent } from '@ionic/react';

export const CardContent: React.FC<{children: React.ReactNode}> = ({ children }) => {
    return (
        <IonCardContent>
            {children}
        </IonCardContent>
    );
};
